import { isBefore } from 'date-fns';
import _isEmpty from 'lodash/isEmpty';

import { getSelectedDate, getTodayInVenueTimezone } from 'features/Schedules/ScheduleCalendar/ScheduleCalendar.helpers';

export const SCHEDULE_LIST_V2_EMPTY_STATE_VARIANT = {
  INTEGRATED_PAST: 'INTEGRATED_PAST',
  INTEGRATED_TODAY_FUTURE: 'INTEGRATED_TODAY_FUTURE',
  MANUAL_PAST: 'MANUAL_PAST',
  MANUAL_TODAY_FUTURE: 'MANUAL_TODAY_FUTURE',
};

export function isScheduleListV2EmptyDay({
  allSchedules,
  isLoadingMoreSchedules,
  isLoadingSchedules,
  isScheduleListV2Enabled,
  isUserLoaded,
}) {
  if (isScheduleListV2Enabled !== true) {
    return false;
  }

  const isEmptyDay = _isEmpty(allSchedules);
  const isLoaded = isUserLoaded && !isLoadingSchedules && !(isEmptyDay && isLoadingMoreSchedules);

  return isLoaded && isEmptyDay;
}

export function isScheduleDateInPast({ now = new Date(), startDate, venueTimezone }) {
  const selectedDate = getSelectedDate({ now, startDate, timeZone: venueTimezone });
  const today = getTodayInVenueTimezone(venueTimezone, now);

  return isBefore(selectedDate, today);
}

export function getScheduleListV2EmptyStateVariant({ isManualStudio, isPastDate }) {
  if (isManualStudio) {
    return isPastDate
      ? SCHEDULE_LIST_V2_EMPTY_STATE_VARIANT.MANUAL_PAST
      : SCHEDULE_LIST_V2_EMPTY_STATE_VARIANT.MANUAL_TODAY_FUTURE;
  }

  return isPastDate
    ? SCHEDULE_LIST_V2_EMPTY_STATE_VARIANT.INTEGRATED_PAST
    : SCHEDULE_LIST_V2_EMPTY_STATE_VARIANT.INTEGRATED_TODAY_FUTURE;
}
